import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {ApiService} from '../api.service';
import {DataStorageService} from '../data-storage.service';

@Injectable()
export class PhoneNumbersToBePortedResolver implements Resolve<any> {

  constructor(private api: ApiService,
              private dataStorageService: DataStorageService) {
  }

  resolve() {
    return this.api.getPortedNumbers(this.dataStorageService.currentState.offerID);
  }
}



// WEBPACK FOOTER //
// ./src/app/resolvers/phoneNumbersToBePortedResolver.ts